import get from 'lodash.get';
import React from 'react';
import {bool, func, object} from 'prop-types';
import {createRefetchContainer, graphql} from 'react-relay';
import { actionCreators } from '../../actions';
import { connect } from 'react-redux';
import MobileNav from '../MobileNav/MobileNav';
import { getUserId, cookieJarConstants } from 'dibs-cookie-jar';
import {AUTH_CLICK_LOGIN, AUTH_CLICK_REGISTER, AUTH_CLICK_LOGOUT} from '../MobileNav/utils/mobileNavConstants';
import {ACTION_LOGIN, ACTION_REGISTER} from '../AccountNav/accountConstants';
import * as userTracking from '../../utils/userTracking';
import authModalLoader from '../../utils/AuthModalLoader';

const { MASQUERADE_BUYER } = cookieJarConstants;

class MobileNavWrapper extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isClient: false,
            fragmentVariables: {
                showMarketingMessages: this.props.showMarketingMessages,
                userId: '',
                userIds: [],
                hasUserId: false
            }
        };
        this.onAuthClick = this.onAuthClick.bind(this);
    }

    componentDidMount() {
        this.setState({ isClient: true });  // eslint-disable-line react/no-did-mount-set-state
        this.updateUser();
    }

    componentDidUpdate(prevProps) {
        if (this.props.updateUserState && !prevProps.updateUserState) {
            this.updateUser();
        }

        if (get(this.props.viewer, 'user.isVerifiedTrade') && !get(prevProps.viewer, 'user')) {
            this.props.updateUserTypeTrade();
        }

        if (this.state.isClient && !this.props.initialTrackingFired) {
            const { viewer } = this.props;
            const userId = getUserId(document.cookie, MASQUERADE_BUYER);
            const hasUserId = !!userId;
            const hasUser = !!viewer.user;

            if (!hasUserId) {
                userTracking.init({ viewer });

            } else if (hasUser) {
                const { user } = viewer;
                userTracking.init({ viewer, user });
            }
        }
    }

    updateUser() {
        if (typeof document === 'undefined') {
            return;
        }
        const userId = getUserId(document.cookie, MASQUERADE_BUYER);
        const hasUserId = !!userId;

        if (hasUserId) {
            this.setState({
                fragmentVariables: {
                    ...this.state.fragmentVariables,
                    hasUserId,
                    userId,
                    userIds: [userId]
                }
            }, () => {
                this.props.relay.refetch(this.state.fragmentVariables);
            });
        }

    }

    handleNavigateAction({path = '/'}) {
        window.location = path;
    }

    onAuthClick(clickType) {
        switch (clickType) {
            case AUTH_CLICK_LOGIN:
                authModalLoader.show({
                    relayEnvironment: this.props.relay.environment,
                    email: localStorage.getItem('userEmail'),
                    action: ACTION_LOGIN
                }).then(this.props.closeMobileMenu);
                break;
            case AUTH_CLICK_REGISTER:
                authModalLoader.show({
                    relayEnvironment: this.props.relay.environment,
                    email: localStorage.getItem('userEmail'),
                    action: ACTION_REGISTER
                }).then(this.props.closeMobileMenu);
                break;
            case AUTH_CLICK_LOGOUT:
                this.props.logoutUser();
                break;
        }
    }

    render() {
        const { viewer } = this.props;
        const { user = null } = viewer;
        const { isClient, fragmentVariables } = this.state;
        const { hasUserId, showMarketingMessages, userIds } = fragmentVariables;

        return (
            <div>
                <MobileNav
                    handleNavigateAction={this.handleNavigateAction}
                    showMarketingMessages={showMarketingMessages}
                    isClient={isClient}
                    onAuthClick={this.onAuthClick}
                    viewer={viewer}
                    hasUserId={hasUserId}
                    user={user}
                    userIds={userIds}
                />
            </div>
        );
    }
}

MobileNavWrapper.propTypes = {
    initialTrackingFired: bool,
    updateUserTypeTrade: func,
    updateUserState: func,
    logoutUser: func.isRequired,
    closeMobileMenu: func.isRequired,
    viewer: object.isRequired,
    user: object,
    relay: object.isRequired,
    showMarketingMessages: bool,
    dispatch: func
};

const mapStateToProps = ({ header }) => ({
    updateUserState: header.updateUserState,
    logoutUser: header.logoutUser
});

const mapDispatchToProps = (dispatch) => {
    return {
        updateUserTypeTrade: () => {
            dispatch(actionCreators.setUserTypeTrade(true));
        },
        closeMobileMenu: () => {
            dispatch(actionCreators.toggleMobileMenu(false));
        }
    };
};

export default createRefetchContainer(connect(mapStateToProps, mapDispatchToProps)(MobileNavWrapper),
    graphql`
        fragment MobileNavWrapper_viewer on Viewer {
            ...MobileNav_viewer
            ...userTracking_viewer @relay(mask: false)

            user(userId: $userId) @include(if: $hasUserId) {
                isVerifiedTrade
                ...userTracking_user @relay(mask: false)
                ...MobileNav_user
            }
        }
    `,
    graphql`
        query MobileNavWrapperRefetchQuery (
                $userId: String!
                $userIds: [String!]
                $hasUserId: Boolean!
                $showMarketingMessages: Boolean!
                $fetchMarketingMessagesTransactions: Boolean!
        ) {
            viewer {
                ...MobileNavWrapper_viewer
            }
        }
    `
);



// WEBPACK FOOTER //
// ./src/components/MobileNavWrapper/MobileNavWrapper.jsx